// extracted by mini-css-extract-plugin
export default {"table":"completedStatus_table__HMKpM"};